import React from "react";
import Image from "src/components/elements/Image";
import Logo from "../../../assets/images/JourneyHubWhite.png";
import { BellIcon, SquareArrowRightExit } from "lucide-react";
import UserDropdown from "src/components/shared/UserDropdown";
import { useNavigate } from "react-router-dom";

const TravelHeader = () => {
  const navigate = useNavigate();

  const navigateToDasboard = () => {
    navigate("/");
  };

  return (
    <header className="relative z-50 flex h-16 flex-shrink-0 items-center gap-5 px-6 text-[11px] font-medium text-white">
      {window.location.pathname === "/travel/dashboard" && (
        <div className="relative mr-auto flex h-16 justify-center">
          <a
            href="/"
            className="flex h-full w-full">
            <Image
              src={Logo}
              alt={"Travel Image"}
              width={"100%"}
              height={"100%"}
              effect={"blur"}
              classes={"object-contain"}
            />
          </a>
        </div>
      )}
      <div className="ml-auto flex w-80 flex-shrink-0 justify-end">
        <button
          onClick={() => {}}
          className="relative flex aspect-square w-10 items-center justify-center gap-2 text-nowrap rounded-full bg-white/5 text-base transition-colors hover:bg-white/15">
          <div className="absolute right-0 top-0 flex h-5 w-5 items-center justify-center rounded-full bg-rose-500 text-[10px] font-semibold">99</div>
          <BellIcon className="h-5 w-5 stroke-2" />
        </button>
        <div className="ml-4 flex cursor-default items-center gap-3 border-l border-white/10 pl-4">
          <UserDropdown
            data={{
              image: "",
              name: "Administrator",
              dropdownData: [
                {
                  _id: "exit",
                  icon: SquareArrowRightExit,
                  label: "Exit",
                  standout: true,
                  hidden: false,
                  onclick: navigateToDasboard,
                },
              ],
            }}
            xPlacement="right"
            nameClasses="!text-white"
          />
        </div>
      </div>
    </header>
  );
};

export default TravelHeader;
